import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AtlasPageView } from '@/components/Atlas/AtlasPageView';
import { TocProvider } from '@/contexts/TocContext';
import { searchParam } from '@/utils/router';

const atlasSearchSchema = z.object({
  branchId: searchParam().optional(),
  versionId: searchParam().optional(),
});

export const Route = createFileRoute('/$organizationName/cb/$codebaseId/atlas/')({
  component: AtlasIndexPage,
  validateSearch: atlasSearchSchema,
});

function AtlasIndexPage() {
  return (
    <TocProvider>
      <div className="mx-auto flex w-full flex-col gap-y-6 pt-4 pb-4">
        <AtlasPageView />
      </div>
    </TocProvider>
  );
}
